import { useState, useEffect, useRef } from "react";

// options: array of { id, name, spec }
export default function EquipmentNameInput({ value, options, onInputChange, onSelect }) {
  const [suggestions, setSuggestions] = useState([]);
  const [focused, setFocused] = useState(false);
  const wrapperRef = useRef();

  // 외부 클릭 시 자동완성 닫기
  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setFocused(false);
        setSuggestions([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 입력 필터링
  useEffect(() => {
    if (!value) {
      setSuggestions([]);
      return;
    }

    const filtered = options
      .filter(
        (opt) =>
          opt.name.toLowerCase().includes(value.toLowerCase()) ||
          opt.spec.toLowerCase().includes(value.toLowerCase())
      )
      .slice(0, 10);

    setSuggestions(filtered);
  }, [value, options]);

  return (
    <div ref={wrapperRef} className="relative">
      <input
        type="text"
        value={value}
        onFocus={() => setFocused(true)}
        onChange={(e) => onInputChange(e.target.value)}
        className="w-full border rounded px-2 py-1"
      />

      {/* 자동완성 표시 조건을 focused까지 포함 */}
      {focused && suggestions.length > 0 && (
        <ul className="absolute left-0 right-0 mt-1 bg-white border rounded shadow-md z-50 max-h-40 overflow-auto">
          {suggestions.map((opt) => (
            <li
              key={opt.id}
              className="px-2 py-1 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                onSelect(opt);
                setFocused(false); // 선택하면 닫기
                setSuggestions([]);
              }}
            >
              {opt.name} ({opt.spec})
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
